<div class="time-up-dialog">
    <!-- Icon -->
    <div class="icon-circle">
        <img src="assets/images/clock-fill.svg" alt="Timer Icon" />
    </div>

    <!-- Title -->
    <h2 class="title">Time’s Up!</h2>

    <!-- Messages -->
    <p class="subtitle" *ngIf="data.submitting">Submitting your answers...</p>
    <p class="subtitle" *ngIf="!data.submitting && !data.error">
        The allotted time for this quiz has ended. <br />
        Your quiz has been automatically submitted.
    </p>
    <p class="subtitle" *ngIf="!data.submitting && data.error">
        The allotted time has ended, but there was an error submitting your quiz.
        Please contact support.
    </p>

    <!-- Action Button -->
    <div class="actions" *ngIf="!data.submitting">
        <button class="btn-view-result" (click)="viewResult()" *ngIf="!data.error">
            View Result
        </button>
    </div>
</div>